import "./src/styles/global.css";
import "./src/styles/hamburger.css";
import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";

export const onRouteUpdate = () => {
  window.scrollTo(0, 0);
};
